module.exports = __webpack_public_path__ + "img/siren.3453a17b.png";